import { render, staticRenderFns } from "./NotificationListItem.vue?vue&type=template&id=5ec20f8a&scoped=true"
import script from "./NotificationListItem.vue?vue&type=script&lang=js"
export * from "./NotificationListItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationListItem.vue?vue&type=style&index=0&id=5ec20f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec20f8a",
  null
  
)

export default component.exports